<template>
  <div>
    <v-row dense>
      <v-col>
        <v-skeleton-loader type="card-heading" transition="fade-transition" />
      </v-col>
      <v-col>
        <v-skeleton-loader type="card-heading" transition="fade-transition" />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <v-skeleton-loader type="card-heading" transition="fade-transition" />
      </v-col>
      <v-col>
        <v-skeleton-loader type="card-heading" transition="fade-transition" />
      </v-col>
      <v-col>
        <v-skeleton-loader type="card-heading" transition="fade-transition" />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <v-skeleton-loader type="image" transition="fade-transition" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "ConductSkeletonLoader",
};
</script>

<style scoped></style>
